<template>
  <div>
    <div
      class="ligne withpointer d-flex flex-row"
      :class=" (product.indexLine%2=== 0?'whiteLine': 'grayLine' )"
    >
      <div v-if="colCheckbox" :style="'width:10%; text-align:center'">
        <v-checkbox
          color="#fec90a"
          class="checkbox-arborescence-line"
          hide-details
          :disabled="true"
          v-model="product.checked"
          @change="checkProduct"
        ></v-checkbox>
      </div>
      <div
        class="withpointer d-flex flex-row product-name"
        :class="'level'+level"
        @click="openProduct(product.pr_id)"
      >
        <div v-if="colFamily">{{product.fa_parent}}</div>
        <div
          class="col-photo ml-2"
          style="background-color:white; width:75px; margin-top:-5px; margin-bottom:-5px"
        >
          <v-img
            :src="`${$config.server_url}/api/1.0/products/image/${product.pr_ref}/1/75/50?d=${now}`"
            contain
            height="50px"
            width="75px"
          ></v-img>
        </div>
        <div class="col-ref ml-2">{{product.pr_ref}}</div>
        <div class="col-marque ml-2">{{product.pr_marque}}</div>
        <div class="col-name ml-2">{{product.pr_name_fr}}</div>
        <div class="col-status ml-2">
          <div v-if="product.pr_status">
            <span class="bis">statut :</span>
            {{product.pr_status}}
          </div>
        </div>
        <div class="col-promo ml-2">
          <div v-if="product.pr_promo">
            <span class="bis">promo :</span>
            {{product.pr_promo}}
          </div>
        </div>
        <div
          v-if="product.pr_catalog!==0"
          class="icon-show-products ml-2 withpointer"
          @click.stop="deleteWinConfirmProduct(product.pr_id, product.pr_name_fr)"
        >
          <icon class="mr-2" name="trash"></icon>
        </div>
        <v-toolbar-items v-if="colProblems" class="col-problems ml-auto">
          <v-menu
            :open-on-hover="true"
            :close-on-click="true"
            :close-on-content-click="true"
            :offset-y="true"
          >
            <template v-slot:activator="{ on }">
              <div class="d-flex flex-row" v-if="product.problems>0" v-on="on">
                <div class="icon-show-products withpointer d-flex flex-row">
                  <icon class="mr-2" name="exclamation-triangle"></icon>
                  <div>{{product.problems}}</div>
                </div>
              </div>
            </template>
            <div class="dropdown-pb">
              <div class="bis">Manque {{product.problems}} image(s) sur ce produit</div>
            </div>
          </v-menu>
        </v-toolbar-items>
      </div>
    </div>
    <!--  <m-product-win-edit
      ref="productwinedit"
      @productWinEditSaved="productWinEditSaved"
      @productWinEditCanceled="$emit('productWinEditCanceled')"
    ></m-product-win-edit>-->
  </div>
</template>

<script>
export default {
  name: "card-tree-product-line",
  components: {},
  props: {
    product: Object,
    level: Number,
    colCheckbox: Boolean,
    colProblems: Boolean,
    familyChecked: Boolean,
    colFamily: Boolean
    // pathToProductEdit: String
  },
  data() {
    return {
      checked: false,
      now: new Date().getTime()
    };
  },
  watch: {},
  computed: {},
  mounted() {
    this.checked = this.familyChecked;
  },
  destroyed() {},
  methods: {
    openProduct(pr_id) {
      // this.$router.push(this.pathToProductEdit + pr_id);
      this.$emit("productWinEditOpened", pr_id);
      this.$refs.productwinedit.open(pr_id);
    },
    checkProduct() {
      // console.log("this.checked", this.checked);
    },
    productWinEditSaved() {
      this.now = new Date().getTime();
      this.$emit("productWinEditSaved");
      /* 
      this.$emit("productWinEditSaved"); */
    },
    deleteWinConfirmProduct(pr_id, name) {
      this.$emit("deleteWinConfirmProduct", pr_id, name);
    }
  }
};
</script>
<style lang="scss" scoped>
.ligne {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.whiteLine {
  background-color: #fff;
}
.grayLine {
  background-color: #f1f1f1;
}
.product-name {
  width: 100%;
}
.col-photo {
  width: 7%;
}
.col-ref {
  width: 6%;
}
.col-marque {
  width: 10%;
}
.col-status {
  width: 7%;
}
.col-promo {
  width: 7%;
}
.col-problems {
  width: 10%;
}
.col-name {
  width: 40%;
}
.checkbox-arborescence-line {
  margin: 0 0 0 30px;
  padding: 0;
}
.dropdown-pb {
  background-color: #fff;
  padding: 10px;
}
</style>